import { useMutation } from '@tanstack/react-query';
import { feedbackService } from 'shared/src/api';

export const useCancelFeedback = () => {
  return useMutation({
    mutationFn: feedbackService.cancelFeedback,
  });
};
